/* AsPadel — comparateur : on choisit les palas par leur photo, le tableau et le radar suivent.
   Un critère absent sur l'une des palas choisies disparaît, il n'est jamais tracé à zéro. */
(function () {
  'use strict';
  if (window.__apComp) return; window.__apComp = true;

  var racine = document.querySelector('[data-comparateur]');
  if (!racine) return;

  var data, conf;
  try {
    data = JSON.parse(racine.querySelector('[data-comp-palas]').textContent);
    conf = JSON.parse(racine.querySelector('[data-comp-config]').textContent);
  } catch (e) { return; }
  delete data._;

  var liste = racine.querySelector('[data-comp-liste]');
  var jetons = racine.querySelector('[data-comp-jetons]');
  var resultat = racine.querySelector('[data-comp-resultat]');
  var recherche = racine.querySelector('[data-comp-recherche]');
  var filtre = racine.querySelector('[data-comp-filtre]');
  var boutons = Array.prototype.slice.call(racine.querySelectorAll('[data-comp-choisir]'));
  var maxi = parseInt(racine.getAttribute('data-max'), 10) || 3;
  var texteVide = racine.getAttribute('data-texte-vide') || '';
  var texteMax = racine.getAttribute('data-texte-max') || '';
  var texteRetirer = racine.getAttribute('data-texte-retirer') || 'Retirer';
  var signeRetirer = racine.getAttribute('data-signe-retirer') || '×';

  var CENTRE = 170, RAYON = 120, PAS = RAYON / 10;
  var choisies = [];

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function couleur(i) { return conf.couleurs[i % conf.couleurs.length] || '#3073C7'; }
  function remplissage(i) {
    if (conf.barreStyle === 'degrade') {
      var g = conf.degrades[i % conf.degrades.length];
      if (g) return g;
    }
    return couleur(i);
  }
  function svgEl(nom, attrs) {
    var e = document.createElementNS('http://www.w3.org/2000/svg', nom);
    for (var k in attrs) if (attrs[k] !== null && attrs[k] !== undefined) e.setAttribute(k, attrs[k]);
    return e;
  }

  /* Axes réellement comparables : notés sur toutes les palas choisies. */
  function axesUtiles(palas) {
    return conf.axes.filter(function (a) {
      return palas.every(function (p) { return p.n && typeof p.n[a.cle] === 'number'; });
    });
  }

  function vecteurs(n) {
    var v = [];
    for (var i = 0; i < n; i++) {
      var angle = -Math.PI / 2 + (2 * Math.PI * i) / n;
      v.push([Math.cos(angle), Math.sin(angle)]);
    }
    return v;
  }

  function polygone(vs, notes) {
    return vs.map(function (u, i) {
      var val = Math.max(0, Math.min(10, notes[i]));
      return (CENTRE + u[0] * PAS * val).toFixed(1) + ',' + (CENTRE + u[1] * PAS * val).toFixed(1);
    }).join(' ');
  }

  function radar(palas, axes) {
    var vs = vecteurs(axes.length);
    var marge = conf.marge || 78;
    var svg = svgEl('svg', {
      'class': 'apcp__svg',
      viewBox: (-marge) + ' 0 ' + (340 + marge * 2) + ' 340',
      role: 'img',
      'aria-label': 'Profil de jeu des palas comparées'
    });

    var grille = svgEl('g', { 'class': 'apcp__grille-radar' });
    for (var r = 1; r <= conf.anneaux; r++) {
      var niveau = (10 * r) / conf.anneaux;
      grille.appendChild(svgEl('polygon', { points: polygone(vs, vs.map(function () { return niveau; })) }));
    }
    svg.appendChild(grille);

    var axesG = svgEl('g', { 'class': 'apcp__axe' });
    vs.forEach(function (u) {
      axesG.appendChild(svgEl('line', {
        x1: CENTRE, y1: CENTRE,
        x2: (CENTRE + u[0] * RAYON).toFixed(1), y2: (CENTRE + u[1] * RAYON).toFixed(1)
      }));
    });
    svg.appendChild(axesG);

    palas.forEach(function (p, i) {
      var notes = axes.map(function (a) { return p.n[a.cle]; });
      var plein = conf.remplir === 'toutes' || (conf.remplir === 'premiere' && i === 0);
      svg.appendChild(svgEl('polygon', {
        'class': 'apcp__zone',
        points: polygone(vs, notes),
        fill: plein ? couleur(i) : 'none',
        'fill-opacity': plein ? conf.opacite : null,
        stroke: couleur(i),
        'stroke-dasharray': i === 0 ? null : (i === 1 ? '6 4' : '2 4')
      }));
    });

    if (conf.taillePoint > 0) {
      palas.forEach(function (p, i) {
        var g = svgEl('g', {});
        vs.forEach(function (u, j) {
          var val = Math.max(0, Math.min(10, p.n[axes[j].cle]));
          g.appendChild(svgEl('circle', {
            cx: (CENTRE + u[0] * PAS * val).toFixed(1),
            cy: (CENTRE + u[1] * PAS * val).toFixed(1),
            r: conf.taillePoint,
            fill: couleur(i)
          }));
        });
        svg.appendChild(g);
      });
    }

    var libelles = svgEl('g', { 'class': 'apcp__etiquette' });
    vs.forEach(function (u, i) {
      var t = svgEl('text', {
        x: (CENTRE + u[0] * 146).toFixed(1),
        y: (CENTRE + u[1] * 146 + 4).toFixed(1),
        'text-anchor': u[0] > 0.3 ? 'start' : (u[0] < -0.3 ? 'end' : 'middle')
      });
      t.textContent = axes[i].libelle;
      libelles.appendChild(t);
    });
    svg.appendChild(libelles);
    return svg;
  }

  function cellule(valeur, indice, note) {
    if (note === undefined) return '<td>' + (valeur == null || valeur === '' ? '—' : esc(valeur)) + '</td>';
    var barre = '';
    if (conf.barres) {
      barre = '<span class="apcp__barre"><span class="apcp__jauge" style="width: ' + (note * 10) +
        '%; background: ' + esc(remplissage(indice)) + '"></span></span>';
    }
    return '<td><span>' + note + '</span>' + barre + '</td>';
  }

  function entetes(palas, libelle) {
    var html = '<thead><tr><th scope="col">' + esc(libelle) + '</th>';
    palas.forEach(function (p, i) {
      html += '<th scope="col"><span class="apcp__entete-pala"><span class="apcp__puce" style="background: ' +
        esc(couleur(i)) + '" aria-hidden="true"></span>' + esc(p.t) + '</span></th>';
    });
    return html + '</tr></thead>';
  }

  /* Fiche technique : uniquement les caractéristiques, les notes vivent sous le radar. */
  function tableauSpecs(palas) {
    var corps = '';
    conf.lignes.forEach(function (l) {
      var valeurs = palas.map(function (p) { return p.s[l.cle]; });
      if (valeurs.every(function (v) { return v == null || v === ''; })) return;
      corps += '<tr><th scope="row">' + esc(l.libelle) + '</th>';
      valeurs.forEach(function (v) { corps += cellule(v); });
      corps += '</tr>';
    });
    if (!corps) return '';
    return '<div class="apcp__defile"><table class="apcp__table">' + entetes(palas, conf.libelleSpec) +
      '<tbody>' + corps + '</tbody></table></div>';
  }

  /* Barres de score, placées sous le radar. */
  function tableauNotes(palas, axes) {
    if (!axes.length) return '';
    var corps = '';
    axes.forEach(function (a) {
      corps += '<tr><th scope="row">' + esc(a.libelle) + '</th>';
      palas.forEach(function (p, i) { corps += cellule(null, i, p.n[a.cle]); });
      corps += '</tr>';
    });
    return '<div class="apcp__notes">' +
      (conf.titreNotes ? '<h2 class="apcp__sous-titre">' + esc(conf.titreNotes) + '</h2>' : '') +
      '<div class="apcp__defile"><table class="apcp__table">' + entetes(palas, conf.libelleNote) +
      '<tbody>' + corps + '</tbody></table></div></div>';
  }

  function sources(palas) {
    return palas.map(function (p) { return esc(p.t) + ' : ' + esc(p.src || conf.sourceAbsente); }).join(' · ');
  }

  function dessinerJetons() {
    jetons.innerHTML = '';
    choisies.forEach(function (h, i) {
      var p = data[h];
      if (!p) return;
      var li = document.createElement('li');
      li.className = 'apcp__jeton';
      li.style.color = couleur(i);
      li.innerHTML = (p.i ? '<img src="' + esc(p.i) + '" alt="" width="34" height="34">' : '') +
        '<strong></strong><button type="button" class="apcp__retirer" aria-label="' + esc(texteRetirer) + '">' +
        esc(signeRetirer) + '</button>';
      li.querySelector('strong').textContent = p.t;
      li.querySelector('button').addEventListener('click', function () { basculer(h); });
      jetons.appendChild(li);
    });
  }

  function dessinerVignettes() {
    boutons.forEach(function (b) {
      var h = b.getAttribute('data-comp-choisir');
      var i = choisies.indexOf(h);
      b.setAttribute('aria-pressed', i > -1 ? 'true' : 'false');
      b.style.color = i > -1 ? couleur(i) : '';
    });
  }

  function rendre() {
    dessinerJetons();
    dessinerVignettes();

    var u = new URL(window.location.href);
    if (choisies.length) u.searchParams.set('p', choisies.join(',')); else u.searchParams.delete('p');
    window.history.replaceState({}, '', u.toString());

    var palas = choisies.map(function (h) { return data[h]; }).filter(Boolean);
    resultat.innerHTML = '';

    if (palas.length < 2) {
      var vide = document.createElement('div');
      vide.className = 'apcp__carte';
      vide.innerHTML = '<p class="apcp__vide"></p>';
      vide.querySelector('p').textContent = choisies.length >= maxi ? texteMax : texteVide;
      resultat.appendChild(vide);
      return;
    }

    var axes = axesUtiles(palas);
    var duo = document.createElement('div');
    duo.className = 'apcp__duo';

    var carteT = null;
    if (conf.tableau) {
      carteT = document.createElement('div');
      carteT.className = 'apcp__carte';
      carteT.innerHTML = (conf.titreTableau ? '<h2 class="apcp__sous-titre">' + esc(conf.titreTableau) + '</h2>' : '') +
        tableauSpecs(palas);
      duo.appendChild(carteT);
    }

    var carteR = null;
    if (conf.radar && axes.length >= 3) {
      carteR = document.createElement('div');
      carteR.className = 'apcp__carte';
      if (conf.titreRadar) {
        var h2 = document.createElement('h2');
        h2.className = 'apcp__sous-titre';
        h2.textContent = conf.titreRadar;
        carteR.appendChild(h2);
      }
      carteR.appendChild(radar(palas, axes));
      duo.appendChild(carteR);
    }

    /* Les barres vont sous le radar ; sans radar, elles rejoignent la fiche technique. */
    var hote = carteR || carteT;
    if (hote) {
      hote.insertAdjacentHTML('beforeend', tableauNotes(palas, axes));
      if (axes.length < conf.axes.length && conf.noteAbsente) {
        var note = document.createElement('p');
        note.className = 'apcp__note-absente';
        note.textContent = conf.noteAbsente;
        hote.appendChild(note);
      }
      var src = document.createElement('p');
      src.className = 'apcp__source';
      src.innerHTML = esc(conf.libelleSource) + ' ' + sources(palas);
      hote.appendChild(src);
    }

    resultat.appendChild(duo);
  }

  function basculer(handle) {
    var i = choisies.indexOf(handle);
    if (i > -1) choisies.splice(i, 1);
    else {
      if (choisies.length >= maxi) return;
      choisies.push(handle);
    }
    rendre();
  }

  function filtrer() {
    var q = recherche ? recherche.value.trim().toLowerCase() : '';
    var f = filtre ? filtre.value : '';
    boutons.forEach(function (b) {
      var okNom = !q || (b.getAttribute('data-nom') || '').indexOf(q) > -1;
      var okForme = !f || b.getAttribute('data-forme') === f;
      if (okNom && okForme) b.parentElement.removeAttribute('data-hors');
      else b.parentElement.setAttribute('data-hors', '');
    });
  }

  boutons.forEach(function (b) {
    b.addEventListener('click', function () { basculer(b.getAttribute('data-comp-choisir')); });
  });
  if (recherche) recherche.addEventListener('input', filtrer);
  if (filtre) filtre.addEventListener('change', filtrer);

  var url = new URL(window.location.href);
  (url.searchParams.get('p') || '').split(',').filter(Boolean).forEach(function (h) {
    if (data[h] && choisies.length < maxi && choisies.indexOf(h) === -1) choisies.push(h);
  });
  rendre();
})();
